import React from 'react';

export const WelcomeScreen = ({ mainPhoto, businessLogo, welcomeText, onContinue, onShowCancellationPolicy }) => {
  return (
    <div className="min-h-screen bg-white relative">
      <div className="max-w-md mx-auto w-full pb-32">
        {/* Scrollable Content */}
        <div className="overflow-y-auto">
          {/* Main Photo */}
          {mainPhoto && (
            <div className="w-full overflow-hidden">
              <img
                src={mainPhoto}
                alt="Business Main Photo"
                className="w-full h-64 object-cover"
              />
            </div>
          )}

          {/* Business Logo */}
          {businessLogo && (
            <div className="w-full py-6 flex justify-center">
              <img
                src={businessLogo}
                alt="Business Logo"
                className="h-16 w-auto object-contain"
              />
            </div>
          )}

          {/* Welcome Text */}
          {welcomeText && (
            <div className="px-6 pb-6">
              <div className="text-right">
                <p className="text-base text-gray-700 text-center" style={{ whiteSpace: 'pre-line' }}>
                  {welcomeText}
                </p>
              </div>
            </div>
          )}
        </div>

        {/* Continue Button - Fixed at bottom */}
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg">
          <div className="max-w-md mx-auto px-6 py-4">
            <button
              onClick={onContinue}
              className="w-full bg-gradient-to-r from-rose-500 to-pink-500 text-white py-4 rounded-2xl font-semibold hover:shadow-lg transition-all duration-300 text-lg"
            >
              לתורים שלי וקביעת תור
            </button>
            {/* Cancellation Policy Link */}
            <button
              onClick={onShowCancellationPolicy}
              className="w-full text-center mt-3 text-sm text-gray-500 hover:text-rose-500 transition-colors duration-200 underline"
            >
              מדיניות ביטולים ושינויים
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
